import { useApp } from '../context.js';
import { Plus, Upload } from '../icons.jsx';
import { CUISINE, VIBE } from '../lib/categories.js';

export default function SortControls() {
    const { activeRestaurantCount, cuisineFilter, handleFileUpload, restaurants, setCuisineFilter, setShowAddForm, setShowUnratedOnly, setSortBy, setVibeFilter, setWantFilter, showUnratedOnly, sortBy, startRandomPicker, t, vibeFilter, wantFilter } = useApp();
    // Only offer tags that are on at least one live place
    const live = restaurants.filter(r => !r.deletedAt);
    const usedCuisine = CUISINE.filter(p => live.some(r => (r.cuisine || []).includes(p.id)));
    const usedVibe = VIBE.filter(p => live.some(r => (r.vibe || []).includes(p.id)));
    const anyBoth = live.some(r => r.wantToTry && r.wantToTry.doug && r.wantToTry.les);
    const toggleIn = (list, set, id) => set(list.includes(id) ? list.filter(x => x !== id) : [...list, id]);
    const chip = (active) => `px-3 py-2 rounded-full text-xs font-semibold apple-button whitespace-nowrap ${active ? `bg-gradient-to-r ${t.accent} text-white` : 'bg-gray-100 text-gray-600'}`;
    return (
        <div className="bg-white/90 apple-card rounded-2xl p-4 shadow-md mb-4">
            <div className="flex gap-2 mb-3">
                <button
                    onClick={() => setShowAddForm(true)}
                    className={`flex-1 bg-gradient-to-r ${t.accent} text-white px-4 py-3 rounded-xl font-semibold apple-button flex items-center justify-center gap-2 shadow-sm`}
                >
                    <Plus size={20} />
                    Add Place
                </button>
                <label className="flex-1 bg-gradient-to-r from-pink-400 to-pink-500 text-white px-4 py-3 rounded-xl font-semibold apple-button flex items-center justify-center gap-2 shadow-sm cursor-pointer">
                    <Upload size={20} />
                    Import
                    <input
                        type="file"
                        accept=".txt"
                        onChange={handleFileUpload}
                        className="hidden"
                    />
                </label>
            </div>

            {/* Random Picker Button */}
            {activeRestaurantCount > 0 && (
                <button
                    onClick={startRandomPicker}
                    className="w-full bg-gradient-to-r from-purple-500 to-indigo-500 text-white px-4 py-3 rounded-xl font-semibold apple-button flex items-center justify-center gap-2 shadow-sm mt-3"
                >
                    🎲 Where should we eat?
                </button>
            )}

            <div className="mt-3 pt-3 border-t border-gray-200">
                <div className="text-xs text-gray-600 mb-2">Sort by:</div>
                <div className="grid grid-cols-3 gap-2 mb-2">
                    <button
                        onClick={() => setSortBy('name')}
                        className={`px-2 py-2 rounded-lg text-xs font-semibold apple-button ${
                            sortBy === 'name'
                                ? `bg-gradient-to-r ${t.accent} text-white`
                                : 'bg-gray-100 text-gray-600'
                        }`}
                    >
                        Name
                    </button>
                    <button
                        onClick={() => setSortBy('rating')}
                        className={`px-2 py-2 rounded-lg text-xs font-semibold apple-button ${
                            sortBy === 'rating'
                                ? `bg-gradient-to-r ${t.accent} text-white`
                                : 'bg-gray-100 text-gray-600'
                        }`}
                    >
                        Top Rated
                    </button>
                    <button
                        onClick={() => setSortBy('recent')}
                        className={`px-2 py-2 rounded-lg text-xs font-semibold apple-button ${
                            sortBy === 'recent'
                                ? `bg-gradient-to-r ${t.accent} text-white`
                                : 'bg-gray-100 text-gray-600'
                        }`}
                    >
                        Recent
                    </button>
                </div>
                <div className="grid grid-cols-3 gap-2">
                    <button
                        onClick={() => setSortBy('favorites')}
                        className={`px-2 py-2 rounded-lg text-xs font-semibold apple-button ${
                            sortBy === 'favorites'
                                ? 'bg-red-400 text-white'
                                : 'bg-gray-100 text-gray-600'
                        }`}
                    >
                        ❤️ Favorites
                    </button>
                    <button
                        onClick={() => setSortBy('unvisited')}
                        className={`px-2 py-2 rounded-lg text-xs font-semibold apple-button ${
                            sortBy === 'unvisited'
                                ? `bg-gradient-to-r ${t.accent} text-white`
                                : 'bg-gray-100 text-gray-600'
                        }`}
                    >
                        Never Been
                    </button>
                    <button
                        onClick={() => setSortBy('topRatedUnvisited')}
                        className={`px-2 py-2 rounded-lg text-xs font-semibold apple-button ${
                            sortBy === 'topRatedUnvisited'
                                ? `bg-gradient-to-r ${t.accent} text-white`
                                : 'bg-gray-100 text-gray-600'
                        }`}
                    >
                        Best Unvisited
                    </button>
                </div>

                {/* Filters */}
                <div className="mt-2 pt-2 border-t border-gray-100 flex flex-wrap gap-2">
                    <button
                        onClick={() => setShowUnratedOnly(!showUnratedOnly)}
                        className={`px-3 py-2 rounded-lg text-xs font-semibold apple-button ${
                            showUnratedOnly
                                ? 'bg-purple-500 text-white'
                                : 'bg-gray-100 text-gray-600'
                        }`}
                    >
                        ⭐ Show Unrated Only
                    </button>
                    {(anyBoth || wantFilter === 'both') && (
                        <button
                            onClick={() => setWantFilter(wantFilter === 'both' ? 'none' : 'both')}
                            aria-pressed={wantFilter === 'both'}
                            className={`px-3 py-2 rounded-lg text-xs font-semibold apple-button ${
                                wantFilter === 'both' ? 'bg-pink-500 text-white' : 'bg-gray-100 text-gray-600'
                            }`}
                        >
                            💛💖 Both want to try
                        </button>
                    )}
                </div>
                {(usedCuisine.length > 0 || usedVibe.length > 0) && (
                    <div className="mt-2 pt-2 border-t border-gray-100">
                        <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1" style={{ scrollbarWidth: 'none' }}>
                            {usedCuisine.map(p => (
                                <button key={p.id} onClick={() => toggleIn(cuisineFilter, setCuisineFilter, p.id)} aria-pressed={cuisineFilter.includes(p.id)} className={chip(cuisineFilter.includes(p.id))}>
                                    {p.emoji} {p.label}
                                </button>
                            ))}
                            {usedVibe.map(p => (
                                <button key={p.id} onClick={() => toggleIn(vibeFilter, setVibeFilter, p.id)} aria-pressed={vibeFilter.includes(p.id)} className={chip(vibeFilter.includes(p.id))}>
                                    {p.emoji} {p.label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
